import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-status-indicator',
    templateUrl: 'status-indicator.component.html',
    styleUrls: ['status-indicator.component.scss']
})
export class StatusIndicatorComponent {
    @Input() status: string;
    @Input() displayText?: string;
    @Input() uppercase?: boolean;

    get statusClass(): string {
        return this.status || '';
    }

    get displayValue(): string {
        return this.displayText || this.status || '';
    }
}